import { PortalTelemetryEvent } from '../../app/telemetry/portalTelemetryEvents';
import { Box, Paper, Grid, Typography } from "@mui/material";
import PaymentUnsuccessful from "../../app/components/PaymentUnsuccessful";
import { useEffect, useRef } from 'react';
import { flushPcsTelemetry, trackPcsEvent, trackPcsReturn } from '../../app/telemetry/portalTelemetry';
import { parsePcsPaymentReturn } from './pcsPaymentReturn';

export default function PcsEnrolmentPaymentSucceed() {
    const { outcome, retryUrl } = parsePcsPaymentReturn(window.location.search, window.location.origin);
    const tracked = useRef(false);
    useEffect(() => {
        if (!tracked.current) {
            tracked.current = true;
            trackPcsReturn(outcome);
        }
    }, [outcome]);

    return <>
        <Box sx={{ minWidth: "100%" }} component={Paper}>

            <Grid container rowSpacing={4} sx={{ marginLeft: '2%' }}>

                <Grid size={{ xs: 12 }}></Grid>

                {outcome === 'success_screen' && <>
                    <Grid size={{ xs: 12 }}>
                        <Typography variant='h4'>Payment successful</Typography>
                    </Grid>

                    <Grid size={{ xs: 12 }} sx={{ marginRight: '2%', marginBottom: '2%' }}>
                        <Typography variant='subtitle1'>
                            Thank you for your payment. Please check your email confirming payment
                            and further instructions on how to download your receipt.
                        </Typography>
                    </Grid>
                </>}

                {outcome === 'cancelled' && <PaymentUnsuccessful retryUrl={retryUrl} onRetry={() => {
                    trackPcsEvent(PortalTelemetryEvent.PaymentRetry);
                    flushPcsTelemetry();
                }} />}
                {outcome === 'unknown' && <Grid size={{ xs: 12 }} sx={{ marginBottom: '2%' }}>
                    <Typography variant='h4'>Payment status unavailable</Typography>
                    <Typography>Please check your payment confirmation email before attempting another payment.</Typography>
                </Grid>}

            </Grid>
        </Box>
    </>
}
